
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { single_news_data } from "../../../data/news_data";
import Meta from "../../../components/Meta";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
const SinglePost = () => {
    const router = useRouter();
    const postId = router.query.single_post;
    const { t } = useTranslation("common");
    const post = single_news_data.find((i) => i.id === postId);
    const pageTitle = t(post.title);
    // Used for translations
    const blogId = post.blogId;
    return (<div>
      <Meta title={pageTitle} desc={t(blogId + ".description")} cannonicalSubPath={`/blog/single_post/${post.id}`}/>

      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- Post --> */}
        <section className="relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full"/>
          </picture>
          {single_news_data
            .filter((item) => item.id === postId)
            .map((item) => {
            const { id, image, title, date, authorName } = item;
            return (<div className="container" key={id}>
                  <header className="mx-auto mb-16 max-w-lg text-center">
                    <h1 className="font-display text-jacarta-700 mb-4 text-2xl dark:text-white sm:text-5xl">
                      {t(title)}
                    </h1>
                    {/* <!-- Author --> */}
                    <div className="inline-flex items-center">
                      <div className="text-left">
                        <span className="dark:text-jacarta-200 text-jacarta-700 text-2xs font-medium tracking-tight">
                          {authorName}
                        </span>

                        {/* <!-- Date / Time --> */}
                        <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                          <span>
                            <time>{date}</time>
                          </span>
                        </div>
                      </div>
                    </div>
                  </header>

                  {/* <!-- Featured image --> */}
                  <figure className="mb-16">
                    <Image width={1170} height={678} src={image} alt={t(blogId + ".alt")} className="rounded-2xl w-full" priority/>
                  </figure>

                  {/* <!-- Article --> */}
                  <article className="mb-12">
                    {/* <!-- Content --> */}
                    <div className="article-content">
                      <h2 className="text-xl">{t(blogId + ".h-2")}</h2>
                      <p className="py-2 text-lg leading-relaxed">
                        {t(blogId + ".p-1")}
                      </p>
                      <p className="py-2 text-lg leading-relaxed">
                        {t(blogId + ".p-2")}
                      </p>
                      <p className="py-2 text-lg leading-relaxed">
                        {t(blogId + ".p-3")}
                      </p>
                      <h3 className="text-xl">{t(blogId + ".h-3")}</h3>
                      <p className="py-2 text-lg leading-relaxed">
                        {t(blogId + ".p-4")}
                      </p>
                    </div>
                  </article>

                  <div className="flex justify-center gap-6 lg:gap-14">
                    <Link href="/blog">
                      <div className="mb-3 inline-flex justify-center items-center space-x-1 text-xs cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 24 24" fill="currentColor" className="text-accent">
                          <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z"/>
                          <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z"/>
                        </svg>

                        <span className="text-accent inline-flex flex-wrap items-center lg:text-lg font-bold space-x-1">
                          {t("go-back-to-blog")}
                        </span>
                      </div>
                    </Link>
                    <Link href="/">
                      <div className="mb-3 inline-flex flex-wrap items-center space-x-1 text-xs cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 24 24" fill="currentColor" className="text-accent">
                          <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z"/>
                          <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z"/>
                        </svg>
                        <span className="text-accent inline-flex flex-wrap items-center lg:text-lg font-bold space-x-1">
                          {t("go-back-to-home")}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>);
        })}
        </section>
        {/* <!-- end post --> */}
      </div>
    </div>);
};
export default SinglePost;

    async function __Next_Translate__getServerSideProps__1947d83db4b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/single_post/[single_post]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1947d83db4b__ as getServerSideProps }
  